require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yamhill-county-court-automated-notification-system.json") })
        }
      }, "path---yamhill-county-court-automated-notification-system");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yamhill-county-court-automated-notification-system!./.cache/json/yamhill-county-court-automated-notification-system.json
// module id = 1066
// module chunks = 231608221292675